import { render, staticRenderFns } from "./artist-realname-detail.vue?vue&type=template&id=980feca6&scoped=true"
import script from "./artist-realname-detail.vue?vue&type=script&lang=js"
export * from "./artist-realname-detail.vue?vue&type=script&lang=js"
import style0 from "./artist-realname-detail.vue?vue&type=style&index=0&id=980feca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980feca6",
  null
  
)

export default component.exports